<template>
  <div id="souls-2">
    <BaseBanner v-bind="bannerProps" @onLoaded="onLoaded"></BaseBanner>

    <!-- Tutorial Overlay -->
    <TutorialOverlay
      v-if="tutorial.isActive.value"
      :current-step="tutorial.currentStep.value"
      :current-step-index="tutorial.currentStepIndex.value"
      :total-steps="tutorial.totalSteps.value"
      :target-rect="tutorial.targetRect.value"
      :is-first-step="tutorial.isFirstStep.value"
      :is-last-step="tutorial.isLastStep.value"
      @prev="tutorial.prevStep"
      @next="tutorial.nextStep"
      @go-to-step="tutorial.goToStep"
    />

    <!-- Wrong Page Popup -->
    <TutorialWrongPagePopup
      :show="tutorial.showWrongPagePopup.value"
      :page-name="tutorial.correctPageDisplayName.value"
      :target-component="tutorial.correctPageComponentName.value"
      @change-judge="handleChangeJudge"
    />

    <main class="content" :style="{ 'background-image': `url(${background.mainBg})` }">
      <template v-if="positions.length != 0">
        <div class="soul-list" :style="{ 'background-image': `url(${background.mapBg})` }">
          <ul>
            <li v-for="(position, index) in positions" :key="index"
                :style="{ left: position.left + 'px', bottom: position.bottom + 'px' }">
              <a @click="setSelectPosition(position.tag)"
                 :class="{ lock: !isUnlocked(position), active: position.tag === selectPositoin.tag }">
                <img class="item__icon" v-onload="{src: getLocationIcon(position)}" alt="icon" width="41px" height="57px">
                {{ position.name }}
              </a>
            </li>
          </ul>
        </div>
        <div class="detail">
          <div v-if="selectPositoin.tag" class="show-conversation"
               :style="{ 'background-image':`url(${icon.conversation_background})`}">
            <div>
              <img :src="icon.conversation_avatar" />
            </div>
            <p class="name">{{ selectPositoin.victim_name }}</p>
            <p
              v-if="isUnlocked(selectPositoin)"
              id="detail"
              v-html="changeLine(selectConversation.title)"
            ></p>
            <p v-else id="detail">
              我以前好像來過這裡，但是不知道為什麼我什麼都想不起來了（缺少關鍵證物）
            </p>
          </div>
          <div v-if="isUnlocked(selectPositoin)" id="options">
            <a v-for="(option, index) in selectConversation.options" :key="index"
               class="option__link"
               @click="setSelectConversation(option.con)">
              <img :src="icon[`conversation_select_${(selectConversation.options.length + index)%selectConversation.options.length+1}`]">
              <p>{{ option.title }}</p>
            </a>
            <a v-if="selectConversation.pre_con === 100"
               @click="resetSelectConversation()"
               class="option__link">
              <img :src="icon.conversation_repeat">
              <p>{{ lastContent }}</p>
            </a>
          </div>
          <p v-if="!selectPositoin.name" id="detail">
            選擇亡魂有記憶的地點
          </p>
        </div>
      </template>
      <template v-else>
        <div class="detail">
          靈陽今日休假～
        </div>
      </template>
    </main>
  </div>
</template>

<script>
import BaseBanner from '../../shared/baseBanner';
import { TutorialOverlay, TutorialWrongPagePopup } from '../../components/tutorial';
import { useSoulsPage } from './useSoulsPage';

/**
 * Refactored Souls page using composition API
 * Template structure matches original index.vue exactly to prevent style mismatch
 */
export default {
  name: 'SoulsPage',

  components: {
    BaseBanner,
    TutorialOverlay,
    TutorialWrongPagePopup
  },

  props: ['memberLineId', 'memberName', 'groupId', 'updateGroupStoryShip', 'updateFinishedDemo'],

  emits: ['change-judge'],

  setup(props, { emit }) {
    const soulsState = useSoulsPage(props);

    const handleChangeJudge = (componentName) => {
      emit('change-judge', componentName);
    };

    return {
      ...soulsState,
      handleChangeJudge
    };
  }
};
</script>

<style lang="scss" scoped src="./style.scss"></style>
